const CONTACT_ID_WILDCARD: string = '*';

export { CONTACT_ID_WILDCARD };
